import i18next from 'i18next'
import type { i18n } from 'i18next'

/* Переводы для каждого языка лежат лишь в 1 файле */
const addBundle = async ({
  userLanguage,
}: {
  userLanguage?: string
}) => {
  try {
    if (!userLanguage || userLanguage.includes('ru')) {
      return
    }

    const { default: translation } = await import(`src/translations/locales/${userLanguage}.trans`)

    i18next.addResourceBundle(userLanguage, userLanguage, translation)
  } catch { /* Empty */ }
}

const initI18next = async ({
  userLanguage,
}: {
  userLanguage?: string
}): Promise<{
  i18next: i18n
  userLanguage: string
}> => {
  const lng = userLanguage || 'ru'

  if (!i18next.isInitialized) {
    await i18next.init({
      lng,
      resources: {},
      interpolation: {
        prefix: '{',
        suffix: '}',
      },
    })
  }

  await addBundle({ userLanguage: lng })

  return { i18next, userLanguage: lng }
}

export default initI18next
